import request from "@/utils/request"; // 导入数据

export function importBatch(data) {
  return request({
    url: "/whg-park/api/longTermImport/import",
    method: "post",
    data: data
  });
}
export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: "/whg-park/api/longTermImport/delete",
    method: "post",
    data: data
  });
}
export function fetchList(data) {
  return request({
    url: "/whg-park/api/longTermImport/list",
    method: "post",
    data: data
  });
}
export function longTermImportData(data) {
  return request({
    url: "/whg-park/api/longTermImportData/list",
    method: "post",
    data: data
  });
}